import React, { useState, useEffect } from 'react';
import image1 from 'assets/artlab/7 (1).jpg';
import image2 from 'assets/artlab/8 (1).webp';
import image3 from 'assets/artlab/9.jpg';
import image4 from 'assets/artlab/10.jpg';
import image5 from 'assets/artlab/11.png';
import image6 from 'assets/artlab/12.jpg';
import axios from "axios";
import { imageBaseURL } from "../../actions/Base_URL";

const ServicesLayout4 = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(3);
  const [hoveredCardId, setHoveredCardId] = useState(null);

  const [servicesData, setServicesData] = useState([
    {
      id: 1,
      type: "mechanical",
      icon: "⚙️",
      title: "Mechanical & Rapid Prototyping Unit",
      description: "Equipped with 3D printers, CNC milling and prototyping tools. Enables students to build precise physical models and product enclosures.",
      image: image6,
    },
    {
      id: 2,
      type: "electrical",
      icon: "🔬",
      title: "Electronics and IoT Unit",
      description: "Houses equipment for PCB design and printing, sensor-based systems, IoT integration, and microcontroller programming. Supports embedded hardware and automation-based projects.",
      image: image1,
    },
    {
      id: 3,
      type: "animation",
      icon: "🎮",
      title: "Animation & Game Design Unit",
      description: "Tools like Unity, Blender, and Unreal Engine for AR/VR, simulations, and digital storytelling. Used for developing interactive games and visual content.",
      image: image3,
    },
    {
      id: 4,
      type: "pouch",
      icon: "🔋",
      title: "Pouch Battery Cell Fabrication Unit",
      description: "Facilities for battery cell assembly, testing, and validation of Lithium IoN Cells. Supports research in e-mobility, renewable energy, and battery storage and management systems.",
      image: image4,
    },
  ]);

  useEffect(() => {
    const fetchServiceImages = async () => {
      try {
        // Fetch all images
        const response = await axios.get("https://api.nvcti.in/api/images");
        let imagesData = [];
        if (response.data && Array.isArray(response.data.images)) {
          imagesData = response.data.images;
        } else if (Array.isArray(response.data)) {
          imagesData = response.data;
        } else if (response.data && Array.isArray(response.data.data)) {
          imagesData = response.data.data;
        }

        if (imagesData.length > 0) {
          setServicesData(prevData => {
            return prevData.map(service => {
              // Find the LATEST image for this service type
              // The API returns images ordered by createdAt DESC, so the first match is the latest
              const matchingImage = imagesData.find(img => img.type === service.type);
              if (matchingImage && matchingImage.path) {
                return { ...service, image: `${imageBaseURL}${matchingImage.path}` };
              }
              return service;
            });
          });
        }
      } catch (error) {
        console.error("Failed to fetch service images:", error);
      }
    };

    fetchServiceImages();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setSlidesToShow(1);
      } else if (window.innerWidth <= 1100) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(3);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (servicesData.length === 0 || servicesData.length <= slidesToShow) {
      return;
    }

    const interval = setInterval(() => {
      setCurrentSlide((prev) =>
        prev >= servicesData.length - slidesToShow ? 0 : prev + 1
      );
    }, 4000);

    return () => clearInterval(interval);
  }, [servicesData.length, slidesToShow]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev >= servicesData.length - slidesToShow ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? servicesData.length - slidesToShow : prev - 1
    );
  };

  const maxSlides = servicesData.length > 0 ? Math.max(1, servicesData.length - slidesToShow + 1) : 1;

  // Dark Theme Colors
  const darkNavy = '#0f172a'; // bg-dark-secondary
  const darkCard = '#1e293b'; // bg-dark-tertiary
  const nvctiOrange = '#f4572e';
  const textWhite = '#ffffff';
  const textGray = '#94a3b8';

  return (
    <div style={{
      fontFamily: "'Roboto', 'Helvetica Neue', Helvetica, Arial, sans-serif",
      backgroundColor: darkNavy,
      padding: '100px 0',
      minHeight: '100vh',
      boxSizing: 'border-box',
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 20px',
        boxSizing: 'border-box',
      }}>
        {/* Header Section */}
        <div style={{
          textAlign: 'center',
          marginBottom: '70px'
        }}>
          <h2 style={{
            color: nvctiOrange,
            fontSize: '14px',
            marginBottom: '15px',
            fontWeight: '900',
            textTransform: 'uppercase',
            letterSpacing: '2px'
          }}>
            Innovation leads to improvement everywhere.
          </h2>
          <h3 style={{
            color: textWhite,
            fontSize: '48px',
            fontWeight: '900',
            margin: '0',
            letterSpacing: '-1px'
          }}>
            State of Art <span style={{ color: nvctiOrange }}>Labs & CoE</span>
          </h3>
          <div style={{
            width: '80px',
            height: '4px',
            backgroundColor: nvctiOrange,
            margin: '25px auto 0',
            borderRadius: '2px'
          }}></div>
        </div>

        {/* Carousel Container */}
        <div style={{ position: 'relative', marginBottom: '10px', overflow: 'hidden', padding: '10px 10px 60px 10px' }}>

          {/* Left Arrow Button */}
          {servicesData.length > slidesToShow && (
            <button
              onClick={prevSlide}
              style={{
                position: 'absolute',
                left: '10px',
                top: '40%',
                transform: 'translateY(-50%)',
                backgroundColor: nvctiOrange,
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                cursor: 'pointer',
                zIndex: 20,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 14px rgba(0,0,0,0.4)',
                transition: 'all 0.3s ease'
              }}
              aria-label="Previous Slide"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>
          )}

          {/* Right Arrow Button */}
          {servicesData.length > slidesToShow && (
            <button
              onClick={nextSlide}
              style={{
                position: 'absolute',
                right: '10px',
                top: '40%',
                transform: 'translateY(-50%)',
                backgroundColor: nvctiOrange,
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                cursor: 'pointer',
                zIndex: 20,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 14px rgba(0,0,0,0.4)',
                transition: 'all 0.3s ease'
              }}
              aria-label="Next Slide"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
          )}

          <div style={{
            display: 'flex',
            transition: 'transform 0.6s cubic-bezier(0.16, 1, 0.3, 1)',
            transform: `translateX(-${currentSlide * (100 / slidesToShow)}%)`,
            gap: '30px',
          }}>
            {servicesData.map((service) => (
              <div key={service.id} style={{
                flex: `0 0 calc(${100 / slidesToShow}% - ${((slidesToShow - 1) * 30) / slidesToShow}px)`,
                boxSizing: 'border-box',
              }}>
                {/* Actual Card */}
                <div
                  style={{
                    backgroundColor: darkCard,
                    borderRadius: '24px',
                    boxShadow: '0 20px 50px rgba(0, 0, 0, 0.3)',
                    textAlign: 'center',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '520px',
                    height: '100%',
                    overflow: 'hidden',
                    border: '1px solid rgba(255, 255, 255, 0.05)',
                    transition: 'all 0.3s ease',
                  }}
                  onMouseEnter={() => setHoveredCardId(service.id)}
                  onMouseLeave={() => setHoveredCardId(null)}
                >
                  {/* Background Icon */}
                  <div style={{
                    position: 'absolute',
                    top: '20px',
                    right: '20px',
                    fontSize: '140px',
                    opacity: '0.03',
                    color: textWhite,
                    zIndex: '0',
                    pointerEvents: 'none',
                    transform: 'rotate(15deg)'
                  }}>
                    {service.icon}
                  </div>

                  {/* Service Body */}
                  <div style={{
                    flexGrow: 1,
                    position: 'relative',
                    padding: '45px 35px 40px 35px',
                    zIndex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                  }}>
                    <div style={{
                      fontSize: '56px',
                      marginBottom: '25px',
                      lineHeight: '1',
                      filter: 'drop-shadow(0 10px 15px rgba(0,0,0,0.2))'
                    }}>
                      {service.icon}
                    </div>

                    <h4 style={{
                      marginBottom: '20px',
                      fontSize: '24px',
                      fontWeight: '800',
                      color: textWhite,
                      lineHeight: '1.2',
                    }}>
                      {service.title}
                    </h4>

                    <p style={{
                      fontSize: '16px',
                      color: textGray,
                      lineHeight: '1.6',
                      margin: '0',
                      fontWeight: '400'
                    }}>
                      {service.description}
                    </p>
                  </div>

                  {/* Image with Hexagonal Clip Path */}
                  <div style={{
                    height: '210px',
                    width: '100%',
                    position: 'relative',
                    clipPath: 'polygon(0% 25%, 50% 0%, 100% 25%, 100% 100%, 0% 100%)',
                    marginTop: 'auto',
                  }}>
                    <img
                      src={service.image}
                      alt={service.title}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'block',
                        filter: hoveredCardId === service.id ? 'brightness(1.1) contrast(1.1)' : 'brightness(0.8)',
                        transition: 'all 0.5s ease'
                      }}
                    />
                  </div>

                  {/* Plus Button */}
                  {hoveredCardId === service.id && (
                    <div style={{
                      position: 'absolute',
                      left: '50%',
                      bottom: '160px',
                      transform: 'translateX(-50%) scale(1)',
                      width: '70px',
                      height: '70px',
                      zIndex: 10,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      animation: 'fadeInUp 0.3s ease-out forwards'
                    }}>
                      <svg
                        style={{ position: 'absolute', width: '100%', height: '100%', filter: 'drop-shadow(0 10px 20px rgba(244, 87, 46, 0.4))' }}
                        viewBox="0 0 110 120"
                      >
                        <path
                          d="M105.000,82.843 L104.995,82.843 C104.982,87.968 102.169,92.700 97.606,95.262 L62.390,115.041 C57.816,117.610 52.181,117.610 47.607,115.041 L12.390,95.262 C7.827,92.700 5.014,87.968 5.001,82.843 L5.000,82.843 L5.000,82.821 C5.000,82.817 4.999,82.812 4.999,82.808 L5.000,82.808 L5.000,39.148 L4.992,39.148 C4.992,34.010 7.810,29.262 12.383,26.694 L47.600,6.915 C52.174,4.346 57.809,4.346 62.383,6.915 L97.599,26.694 C102.157,29.253 104.967,33.977 104.987,39.094 L105.000,39.094 L105.000,82.843 Z"
                          fill={nvctiOrange}
                        />
                      </svg>
                      <span style={{
                        color: 'white',
                        fontSize: '32px',
                        fontWeight: '700',
                        position: 'relative',
                        zIndex: 1,
                      }}>
                        +
                      </span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Dots Navigation */}
          {servicesData.length > slidesToShow && (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px',
              marginTop: '50px',
            }}>
              {Array.from({ length: maxSlides }).map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  style={{
                    width: currentSlide === index ? '30px' : '10px',
                    height: '10px',
                    borderRadius: '5px',
                    border: 'none',
                    backgroundColor: currentSlide === index ? nvctiOrange : 'rgba(255,255,255,0.2)',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    padding: 0,
                  }}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          )}
        </div>
      </div>
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translate(-50%, 20px); }
          to { opacity: 1; transform: translate(-50%, 0); }
        }
      `}</style>
    </div>
  );
};

export default ServicesLayout4;